"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = isOverflowing;

var _getWindow = _interopRequireDefault(require("./getWindow"));

var _ownerDocument = _interopRequireDefault(require("./ownerDocument"));

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument["default"])(node);
  var win = (0, _getWindow["default"])(doc);
  var fullWidth = win.innerWidth;

  if (doc.body) {
    return doc.body.clientWidth < fullWidth;
  }

  return false;
}
/**
 * Check if the document is overflowing and account for the scrollbar width
 * @param container The container to check
 * @returns The document is overflowing
 */


function isOverflowing(container) {
  var win = (0, _getWindow["default"])(container);
  var isBody = container && container.tagName.toLowerCase() === 'body';
  return win || isBody ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}

module.exports = exports.default;